import { ClinicalStatus } from '../../admin/constants/general';
import { ActionRequiredItemEnum, ClinicalRelationships } from '../../constants';
import {
  FORTA_BLUE,
  FORTA_DOCS,
  FORTA_GRAY1,
  FORTA_ORANGE,
  FORTA_SUCCESS,
  FORTA_WHITE,
} from '../../utils/colors';

export const activeButtonStyles = {
  backgroundColor: FORTA_BLUE.primary,
  color: FORTA_WHITE,
  boxShadow: 'none',
  borderRadius: '20px',
  '& span': {
    fontSize: '14px !important',
  },
};

export const buttonStyles = {
  backgroundColor: FORTA_WHITE,
  color: FORTA_BLUE.primary,
  boxShadow: 'none',
  borderRadius: '20px',
  '& span': {
    fontSize: '14px !important',
  },
};

export enum AssignmentType {
  ALL = 'ALL',
  HOME = 'Home',
  BOBBING = 'BOBBING',
  SUBSTITUTE = 'SUBSTITUTE',
}

export const cardChipStyles = {
  color: FORTA_BLUE.primary,
  backgroundColor: FORTA_GRAY1,
  p: '2px 8px',
  lineHeight: '21px',
  mr: 1,
  fontSize: 14,
  fontWeight: 700,
  borderRadius: '16px',
};

export const ActionReqTypeMap = {
  [ActionRequiredItemEnum.Parent]: {
    name: 'Parent SN (97156)',
    color: FORTA_DOCS.PSN_56,
  },
  [ActionRequiredItemEnum.Client]: {
    name: 'Client SN (97155)',
    color: FORTA_DOCS.CSN_55,
  },
  [ActionRequiredItemEnum.Bt]: {
    name: 'BT SN ',
    color: FORTA_DOCS.BTSN,
  },
  [ActionRequiredItemEnum.Assessment]: {
    name: 'Assessment (97151)',
    color: FORTA_DOCS.AN_51,
  },
  [ActionRequiredItemEnum.Assessment2]: {
    name: 'Assessment (97152)',
    color: FORTA_DOCS.AN_52,
  },
  [ActionRequiredItemEnum.GroupParent]: {
    name: 'Group Supervision',
    color: FORTA_DOCS.GPSN_57,
  },
  [ActionRequiredItemEnum.TreatmentPlan]: {
    name: 'Treatment Plan',
    color: FORTA_DOCS.TP,
  },
  [ActionRequiredItemEnum.Session]: {
    name: 'Session (97153)',
    color: FORTA_DOCS.SN_53,
  },
};

export const AssignmentMap = {
  [ClinicalRelationships.HomeBcba]: 'Home',
  [ClinicalRelationships.BobbingBcba]: 'Bobbing',
  [ClinicalRelationships.SubstituteBCBA]: 'Substitute',
};

export const ClinicalStatusMap = {
  [ClinicalStatus.CLINICAL]: 'Clinical',
  [ClinicalStatus.PRE_CLINICAL]: 'PreClinical',
};

export const ClinicalRelationshipColorMap = {
  [ClinicalStatus.CLINICAL]: FORTA_SUCCESS,
  [ClinicalStatus.PRE_CLINICAL]: FORTA_ORANGE,
};
